import styled from "@emotion/styled"

const ArticleAsideTabsHeading = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #e3e3ec;
`

export default ArticleAsideTabsHeading
